/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, object } from "prop-types";
import { collectionToStories } from "@quintype/components";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import { PrimaryColumn, SecondaryColumn, TertiaryColumn } from "./Columns";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./three-col-nineteen-stories-var-two.m.css";

export const ThreeColNineteenStoriesVarTwo = ({ collection, extraProp = "" }) => {
  const stories = collectionToStories(collection);

  if (!stories.length) return null;

  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";
  const {
    photos_label,
    show_main_story_hero_image,
    show_row_ad_unit,
    show_row_separator,
    row_background_color,
    text_color,
    show_row_ad_unit_bottom,
    show_read_time,
    show_timestamp,
    show_story_separator,
  } = get(collection, ["associated-metadata"], {});
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const sectionSlug = extraProp;
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  return (
    <div className="row-component" styleName="top-component-container">
      <div
        style={{
          backgroundColor: row_background_color,
          paddingTop: row_background_color ? "15px" : "none",
        }}
      >
        <div
          styleName="three-col-nineteen-stories-var-2 first-variation"
          style={{
            color: text_color,
          }}
        >
          <PrimaryColumn
            stories={stories.slice(0, 5)}
            isMobile={isMobile}
            showReadTime={show_read_time}
            showTimestamp={show_timestamp}
            showStorySeparator={show_story_separator}
            showHeroImage={show_main_story_hero_image}
            sectionSlug={sectionSlug}
          />
          {stories.length > 5 && (
            <SecondaryColumn
              stories={stories.slice(5, 13)}
              showAd={isMobile}
              showReadTime={show_read_time}
              showTimestamp={show_timestamp}
              showStorySeparator={show_story_separator}
              rowAdUnit={show_row_ad_unit}
              collection={collection}
              isMobile={isMobile}
              sectionSlug={sectionSlug}
            />
          )}
          <TertiaryColumn
            stories={stories.slice(13, 19)}
            showAd={!isMobile}
            showReadTime={show_read_time}
            showTimestamp={show_timestamp}
            showStorySeparator={show_story_separator}
            rowAdUnit={show_row_ad_unit}
            photosLabel={photos_label}
            deviceType={deviceType}
            collection={collection}
            sectionSlug={sectionSlug}
          />
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

ThreeColNineteenStoriesVarTwo.propTypes = {
  collection: object,
  stories: array,
};

ThreeColNineteenStoriesVarTwo.storyLimit = 19;
